import api from './api';
import type { AssessmentRecord, ResultAnalysisReport } from '../types';

/**
 * Continuous Assessments and Analysis API Service
 */
export const assessmentService = {
  /**
   * Loads class mark rosters for all subjects in a term
   */
  getTermMarksGrid: async (
    classId: number, 
    term: number,
    type: number,
    year: number
  ): Promise<any> => {
    const response = await api.get(`/assessments/class/${classId}/term/${term}?type=${type}&year=${year}`);
    return response.data.success ? response.data.data : null;
  },

  /**
   * Submits batch pupil marks updates for the entire term grid
   */
  saveTermMarksGrid: async (
    classId: number, 
    term: number, 
    type: number,
    academicYearId: number, 
    scores: { pupil_id: number; subject_id: number; score: number }[]
  ): Promise<boolean> => {
    const response = await api.post('/assessments/term-grid', {
      class_id: classId,
      term,
      type,
      academic_year_id: academicYearId,
      scores
    });
    return response.data.success;
  },

  /**
   * Pulls real-time continuous assessment reports showing boys vs. girls sat, failed, passed and pass rate metrics
   */
  getResultAnalysis: async (
    classId: number, 
    subjectId: number, 
    term: number, 
    week: number,
    yearId: number
  ): Promise<ResultAnalysisReport | null> => {
    const response = await api.get(`/reports/result-analysis/${classId}/subject/${subjectId}/term/${term}/week/${week}?year=${yearId}`);
    return response.data.success ? response.data.data : null;
  },

  submitResults: async (classId: number, subjectId: number, term: number, type: number, yearId: number): Promise<boolean> => {
    const response = await api.post('/results/submit', { class_id: classId, subject_id: subjectId, term, type, academic_year_id: yearId });
    return response.data.success;
  },

  validateResults: async (classId: number, subjectId: number, term: number, type: number, yearId: number): Promise<boolean> => {
    const response = await api.post('/results/validate', { class_id: classId, subject_id: subjectId, term, type, academic_year_id: yearId });
    return response.data.success;
  },

  lockResults: async (classId: number, subjectId: number, term: number, type: number, yearId: number): Promise<boolean> => {
    const response = await api.post('/results/lock', { class_id: classId, subject_id: subjectId, term, type, academic_year_id: yearId });
    return response.data.success;
  },

  unlockResults: async (classId: number, subjectId: number, term: number, type: number, yearId: number): Promise<boolean> => {
    const response = await api.post('/results/unlock', { class_id: classId, subject_id: subjectId, term, type, academic_year_id: yearId });
    return response.data.success;
  }
};

export default assessmentService;
